export default __webpack_public_path__ + "src/assets/link-out.0acfed12887ab1dc07f2bb4b7bc4ad9c.svg";